import { useMutation, useQueryClient } from '@tanstack/react-query';
import { operations } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

export type CreateSupplierCompanyBody =
  operations['createSupplierIntegrationCompany']['requestBody']['content']['application/json'];

export type CreateSupplierCompanyResponse =
  operations['createSupplierIntegrationCompany']['responses'][201]['content']['application/json'];

const useCreateSupplierCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['createSupplierCompany'],
    mutationFn: (body: CreateSupplierCompanyBody) => {
      return apiClient.post('api/supplier-experience/companies', { json: body }).json<CreateSupplierCompanyResponse>();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companyStatus'] });
    },
  });
};

export default useCreateSupplierCompany;
